import { render, staticRenderFns } from "./commonDisease.vue?vue&type=template&id=535c9cca&"
import script from "./commonDisease.vue?vue&type=script&lang=js&"
export * from "./commonDisease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports